import { Component, OnInit } from "@angular/core";
import { ClientService } from "../service/client.service";
import { CallTypeModel } from "../model/callType";

@Component({
  selector: "app-edit-call-type",
  templateUrl: "./edit-call-type.component.html",
  styleUrls: ["./edit-call-type.component.css"],
})
export class EditCallTypeComponent implements OnInit {
  callTypes: CallTypeModel[] = [];

  newCallTypeDescription: string = "";

  constructor(private clientService: ClientService) {}

  ngOnInit() {
    this.getAllCallTypes();
  }

  getAllCallTypes = () => {
    this.clientService.getAllCallTypes().subscribe(
      (response: CallTypeModel[]) => {
        this.callTypes = response;
        console.log("callTypes:", this.callTypes);
      },
      (error) => {
        console.log(error);
      },
    );
  };

  deleteCallType(callTypeId: number) {
    const isConfirmed = confirm("אתה בטוח שברצונך למחוק את התקלה הזו?");

    if (!isConfirmed) {
      return;
    }

    this.clientService.deleteCallType(callTypeId).subscribe(
      () => {
        alert("נמחק בהצלחה!");
        this.getAllCallTypes();
      },
      (error) => console.log(error),
    );
  }

  editCallType(callType: CallTypeModel) {
    const newDescription = prompt(
      "עדכן תיאור סוג פניה:",
      callType.CallTypeDescription,
    );

    if (newDescription === null || newDescription.trim() === "") {
      return;
    }

    const updatedCallType: CallTypeModel = {
      CallTypeId: callType.CallTypeId,
      CallTypeDescription: newDescription,
    };

    this.clientService.updateCallType(updatedCallType).subscribe(
      () => {
        alert("עודכן בהצלחה!");
        this.getAllCallTypes();
      },
      (error) => console.log(error),
    );
  }

  addCallType() {

  if (!this.newCallTypeDescription || this.newCallTypeDescription.trim() === "") {
    alert("נא להזין תיאור");
    return;
  }

  const newCallType: CallTypeModel = {
    CallTypeId: 0, // backend will generate
    CallTypeDescription: this.newCallTypeDescription
  };

  this.clientService.addCallType(newCallType).subscribe(
    () => {
      alert("נוסף בהצלחה!");
      this.newCallTypeDescription = "";
      this.getAllCallTypes();
    },
    (error) => console.log(error)
  );
}

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/edit-call-type/edit-call-type.component.ts